import React from 'react';
import './Loader.scss';

const LoaderLayout = () => {
  return <div className='loader_layout'>
   <img  src={require('./flame.gif')}/>
  </div>;
};

export default LoaderLayout;
